import { render, staticRenderFns } from "./sales-by-sales.vue?vue&type=template&id=70a010ae&scoped=true&"
import script from "./sales-by-sales.vue?vue&type=script&lang=js&"
export * from "./sales-by-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a010ae",
  null
  
)

export default component.exports